import React from 'react';
import {useTranslation} from 'next-i18next';
import {Button, SimpleGrid, VStack} from '@tempo/core';
import ClaimTypeButton from './ClaimTypeButton';
import {ClaimAccessType} from '../../types';
import PageLayout from '@deezer/next/shared/layouts/PageLayout';
import TitleRow from '@components/PageElements/PageHeader/TitleRow';
import FooterRow from '@components/PageElements/FooterRow';

type SelectProfileTypeFormCardProps = {
	claimType?: ClaimAccessType;
	onClaimTypeChange: (claimType: ClaimAccessType) => void;
	onContinue: () => void;
};

const profileTypes = Object.values(ClaimAccessType).filter(i =>
	isNaN(Number(i)),
);

const ClaimTypeFormCard = ({
	claimType,
	onClaimTypeChange,
	onContinue,
}: SelectProfileTypeFormCardProps) => {
	const {t} = useTranslation('d4c');

	return (
		<PageLayout
			data-testid="select-claim-type-card"
			header={<TitleRow title={t('requestaccess_title_whoareyou_d4c-web')} />}
			footer={
				<FooterRow
					rightElements={
						<>
							<Button
								data-testid="continue-button"
								onClick={onContinue}
								size="small"
							>
								{t('generic_action_continue_d4c-web')}
							</Button>
						</>
					}
				/>
			}
		>
			<VStack
				as="form"
				maxWidth="4xl"
				px="spacing.s"
				py="spacing.xl"
				spacing="spacing.l"
				margin="auto"
			>
				<SimpleGrid columns={{base: 2, sm: 4}} spacing={8}>
					{profileTypes.map(c => (
						<ClaimTypeButton
							key={c}
							claimType={c}
							isSelected={c === claimType}
							onClick={onClaimTypeChange}
						/>
					))}
				</SimpleGrid>
			</VStack>
		</PageLayout>
	);
};

export default ClaimTypeFormCard;
